import { light } from '@fortawesome/fontawesome-svg-core/import.macro';
import { useContext } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import Button from '../../components/Button';
import Carousel from '../../components/Carousel';
import ChartCard from '../../components/ChartCard';
import DefaultCard from '../../components/DefaultCard';
import FingerTipsLinks from '../../components/FingertipsLinks/FingertipsLinks';
import {
  DcDashboardProvider,
  DcDashboardStore,
} from '../../providers/dcDashboard';
import {
  ACCOUNT_ACTIVITY_ROUTE,
  PENSION_PROFILE_ROUTE,
  RETIREMENT_PLANNING_ROUTE,
} from '../../routes/types';
import SavingsSnapshot from '../widgets/dashboards/SavingsSnapshot';
import TotalRewardsHalf from '../widgets/dashboards/TotalRewardsHalf';

const linksData = [
  {
    linkHeader: 'Account Activity',
    route: ACCOUNT_ACTIVITY_ROUTE,
  },

  {
    linkHeader: 'Pension Profile',
    route: PENSION_PROFILE_ROUTE,
  },
];

const dataCompanyContributions = {
  // The "grid -> padding" is a hack to reduce the huge margins that donut renders.
  // See: https://github.com/apexcharts/apexcharts.js/issues/1272
  grid: {
    padding: {
      left: -20,
      top: -10,
    },
  },
  legend: {
    show: false,
  },

  dataLabels: {
    enabled: false,
  },
  responsive: [
    {
      breakpoint: 480,
      options: {
        grid: {
          padding: {
            left: 0,
            top: 10,
          },
        },
        legend: {
          show: false,
        },
        title: {},
      },
    },
  ],
  colors: ['#074CBC', '#F48462', '#07B4A0', '#EEA968', '#92E3A9'],
  series: [95072, 15905, 14791, 6500, 0],
  labels: [
    'Compensation',
    'Health and Welfare',
    'Retirement',
    'Equity',
    'Other Benefits',
  ],

  tooltip: {
    enabled: false,
  },

  // DISPLAY TEXT IN DONUT CENTRE:
  plotOptions: {
    pie: {
      donut: {
        labels: {
          show: true,
          name: {
            offsetY: 10,
          },
          total: {
            show: true,
            showAlways: true,
            fontSize: '18px',
            fontFamily: 'Roboto, Arial, sans-serif',
            fontWeight: 500,
            label: `$132,268`,
            formatter: function (a: any) {
              return '';
            },
          },
        },
      },
    },
  },
};

const DcUnpaidLeaveDashboardView = () => {
  const { fingertipLinks, companiesMessages, savingsSnapshot } =
    useContext(DcDashboardStore) || {};
  const navigate = useNavigate();

  return (
    <Container className={'cnd-custom-container-large mb-12 px-lg-9 px-xl-0'}>
      <Row>
        <Col className="mt-7 mt-lg-11 col-12 col-lg-7">
          <DefaultCard
            className="h-100 flex-column flex-sm-row "
            variant="blue-motif"
            leftHeading={<div className="text-sm-20-lg-32">Welcome, Terry</div>}
          />
        </Col>
        <Col className="mt-7 mt-lg-11 col-12 col-lg-5">
          <DefaultCard
            className="flex-column"
            variant="blue"
            leftHeading={<div className="text-sm-20-lg-32">Current Events</div>}
            leftSubheading={
              <Container className="p-0 mb-7">
                <Row>
                  <Col className={'col-12'}>
                    <span
                      className={
                        'py-3 d-block w-100 fw-light text-nowrap text-sub1'
                      }
                    >
                      There are currently no events.
                    </span>
                  </Col>
                </Row>
              </Container>
            }
          />
        </Col>
      </Row>

      <Row className="m-0 mt-12 p-0">
        <Col className="m-0 p-0 d-flex flex-column col-12 col-lg-7 pe-lg-4">
          <SavingsSnapshot
            savingsSnapshot={savingsSnapshot}
            linksData={linksData}
          />
        </Col>

        <Col className="col-12 col-lg-5 pe-0">
          <Col className="pe-lg-0 col-12">
            <FingerTipsLinks data={fingertipLinks} className="p-0" />
          </Col>
        </Col>
      </Row>

      <Row className="m-0 mt-12 p-0">
        <Col className="col-12 col-lg-6 ps-lg-0">
          <TotalRewardsHalf
            dataCompanyContributions={dataCompanyContributions}
          />
        </Col>
        <Col className="col-12 col-lg-6 pe-lg-0">
          <ChartCard
            title="Retirement Confidence"
            text={
              <p className="text-center text-lg-start  text-sub1 text-light-grey-normal fw-light lh-xs">
                Saving 8% will raise your Retirement Confidence level to 75%.
                Use the{' '}
                <Link
                  to={RETIREMENT_PLANNING_ROUTE}
                  className={
                    'fw-bold text-light-grey-normal text-decoration-none'
                  }
                >
                  Retirement Planning
                </Link>{' '}
                tool to further customize your strategy.
              </p>
            }
            button={
              <Button
                className="col-12 col-lg-7"
                variant="primary"
                rightIcon={light('person-cane')}
                size="sm"
                onClick={() => navigate(RETIREMENT_PLANNING_ROUTE)}
              >
                Retirement Planning
              </Button>
            }
          />
        </Col>
      </Row>

      <Row className="m-0 mt-12 p-0">
        <Carousel data={companiesMessages} />
      </Row>
    </Container>
  );
};

const DcUnpaidLeaveDashboard = () => {
  return (
    <DcDashboardProvider>
      <DcUnpaidLeaveDashboardView />
    </DcDashboardProvider>
  );
};

export default DcUnpaidLeaveDashboard;
